import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function TemperatureGuide() {
  return <LocalizedWeatherGuidePage guideKey="temperature" />;
}